import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";

import { getStates } from "../../api/services/StateService";

const DistrictForm = ({
    show,
    onClose,
    onSubmit,
    initialData,
    loading
}) => {
    const [states, setStates] = useState([]);
    const [stateCode, setStateCode] = useState("");
    const [name, setName] = useState("");
    const [errors, setErrors] = useState({});

    /* -------------------------------------------------------------------------- */
    /* LOAD STATES                                                                */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        const loadStates = async () => {
            try {
                const data = await getStates();
                setStates(data || []);
            } catch (err) {
                console.error("Failed to load states:", err);
            }
        };

        if (show) loadStates();
    }, [show]);

    /* -------------------------------------------------------------------------- */
    /* LOAD DATA FOR EDIT                                                         */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        if (initialData) {
            setStateCode(initialData.stateCode || "");
            setName(initialData.name || "");
        } else {
            setStateCode("");
            setName("");
        }
    }, [initialData]);

    /* -------------------------------------------------------------------------- */
    /* VALIDATION                                                                 */
    /* -------------------------------------------------------------------------- */
    const validate = () => {
        const newErrors = {};

        if (!stateCode) newErrors.stateCode = "State is required";
        if (!name.trim()) newErrors.name = "District name is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /* -------------------------------------------------------------------------- */
    /* SUBMIT HANDLER                                                             */
    /* -------------------------------------------------------------------------- */
    const handleSubmit = () => {
        if (!validate()) return;

        onSubmit({
            stateCode,
            name: name.trim()
        });
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {initialData ? "Update District" : "Add District"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    {/* STATE */}
                    <Form.Group className="mb-3">
                        <Form.Label>State</Form.Label>
                        <Form.Select
                            value={stateCode}
                            onChange={(e) => setStateCode(e.target.value)}
                            isInvalid={!!errors.stateCode}
                            disabled={!!initialData}
                        >
                            <option value="">Select State</option>
                            {states.map((state) => (
                                <option key={state._id} value={state.code}>
                                    {state.name} ({state.code})
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {errors.stateCode}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {/* DISTRICT NAME */}
                    <Form.Group>
                        <Form.Label>District Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            isInvalid={!!errors.name}
                            placeholder="Udupi"
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? "Saving..." : initialData ? "Update" : "Create"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

DistrictForm.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    loading: PropTypes.bool
};

export default DistrictForm;
